import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    employeesCorrection: [],
    totalItems:0,
    employeeCorrection: {
        employmentDatesCorrection:null,
        leaveBalancesCorrection:null
    }
};

const getters = {
    index: state => employeeCorrectionId => state.employeesCorrection.findIndex(i => i.employeeCorrectionId === employeeCorrectionId)
};

const mutations = {
    setEmployeesCorrection: (state, r) => (state.employeesCorrection = r),
    setTotalItems: (state, r) => (state.totalItems = r),
    setEmployeeCorrection: (state, r) => (state.employeeCorrection = r),
    add: (state, r) => state.employeesCorrection.unshift(r),
    edit: (state, { index, r }) => state.employeesCorrection.splice(index, 1, r),
    delete: (state, index) => state.employeesCorrection.splice(index, 1),
    approve: (state, index) => state.employeesCorrection[index].status = status.active,
    reject: (state, index) => state.employeesCorrection[index].status = status.rejected,
   
};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.employeesCorrection.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeesCorrection", response.data.employeesCorrection);
            commit("setTotalItems", response.data.totalItems);

           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.employeeCorrection);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async approve({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.approve(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("approve", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async reject({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.reject(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("reject", index);
        } catch (error) {

            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setEmployeeCorrection", {});
            startLoading()
            const response = await dataService.employeesCorrection.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setEmployeeCorrection", response.data.employeeCorrection);
         
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employeeCorrection);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getAdministrativeInfo(_, id) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.getAdministrativeInfo(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employeeAdministrativeInfos);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
     async getEmployeeVacationsBalances(_, id) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.getEmployeeVacationsBalances(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employeeVacationsBalances);
           
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.employeesCorrection.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
         
            const index = getters.index(id);
            commit("edit", { index, r: response.data.employeeCorrection });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },


};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
